const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:4000';

const getAuthHeaders = () => {
  const token = localStorage.getItem('adminToken') || sessionStorage.getItem('adminToken');
  return {
    'Authorization': token ? `Bearer ${token}` : '',
    'Content-Type': 'application/json'
  };
};

export const listBlogs = async (params = {}) => {
  const queryString = new URLSearchParams(params).toString();
  const response = await fetch(`${API_BASE_URL}/api/v1/admin/blogs${queryString ? `?${queryString}` : ''}`, {
    headers: getAuthHeaders()
  });
  
  if (!response.ok) {
    const error = await response.json().catch(() => ({}));
    throw new Error(error.message || 'Failed to fetch blogs');
  }
  
  const result = await response.json();
  return result.data || [];
};

export const getBlogById = async (id) => {
  const response = await fetch(`${API_BASE_URL}/api/v1/admin/blogs/${id}`, {
    headers: getAuthHeaders()
  });
  
  if (!response.ok) {
    const error = await response.json().catch(() => ({}));
    throw new Error(error.message || 'Failed to fetch blog');
  }
  
  const result = await response.json();
  return result.data;
};

export const createBlog = async (data, videoFile = null) => {
  let body;
  let headers = getAuthHeaders();
  
  if (videoFile) {
    // Use FormData for file upload
    const formData = new FormData();
    Object.keys(data).forEach(key => {
      formData.append(key, data[key]);
    });
    formData.append('video', videoFile);
    body = formData;
    // Remove Content-Type header to let browser set it with boundary
    headers = { 'Authorization': headers.Authorization };
  } else {
    body = JSON.stringify(data);
  }
  
  const response = await fetch(`${API_BASE_URL}/api/v1/admin/blogs`, {
    method: 'POST',
    headers,
    body
  });
  
  if (!response.ok) {
    const error = await response.json().catch(() => ({}));
    throw new Error(error.message || 'Failed to create blog');
  }
  
  const result = await response.json();
  return result.data;
};

export const updateBlog = async (id, data, videoFile = null) => {
  let body;
  let headers = getAuthHeaders();
  
  if (videoFile) {
    // Use FormData for file upload
    const formData = new FormData();
    Object.keys(data).forEach(key => {
      formData.append(key, data[key]);
    });
    formData.append('video', videoFile);
    body = formData;
    // Remove Content-Type header to let browser set it with boundary
    headers = { 'Authorization': headers.Authorization };
  } else {
    body = JSON.stringify(data);
  }
  
  const response = await fetch(`${API_BASE_URL}/api/v1/admin/blogs/${id}`, {
    method: 'PATCH',
    headers,
    body
  });
  
  if (!response.ok) {
    const error = await response.json().catch(() => ({}));
    throw new Error(error.message || 'Failed to update blog');
  }
  
  const result = await response.json();
  return result.data;
};

export const toggleBlog = async (id, isActive) => {
  const response = await fetch(`${API_BASE_URL}/api/v1/admin/blogs/${id}/toggle`, {
    method: 'PATCH',
    headers: getAuthHeaders(),
    body: JSON.stringify({ is_active: isActive })
  });
  
  if (!response.ok) {
    const error = await response.json().catch(() => ({}));
    throw new Error(error.message || 'Failed to toggle blog');
  }
  
  const result = await response.json();
  return result.data;
};

export const deleteBlog = async (id) => {
  const response = await fetch(`${API_BASE_URL}/api/v1/admin/blogs/${id}`, {
    method: 'DELETE',
    headers: getAuthHeaders()
  });
  
  if (!response.ok) {
    const error = await response.json().catch(() => ({}));
    throw new Error(error.message || 'Failed to delete blog');
  }
  
  const result = await response.json();
  return result.data;
};

export const normalizeBlog = (raw) => {
  if (!raw) return null;
  return {
    id: raw.id,
    title: raw.title,
    slug: raw.slug,
    short_description: raw.short_description,
    youtube_url: raw.youtube_url,
    youtube_video_id: raw.youtube_video_id,
    video_type: raw.video_type || 'youtube',
    video_url: raw.video_url,
    video_file_name: raw.video_file_name,
    video_file_size: raw.video_file_size,
    video_mime_type: raw.video_mime_type,
    thumbnail_url: raw.thumbnail_url,
    display_order: raw.display_order || 0,
    is_active: raw.is_active !== false,
    created_at: raw.created_at,
    updated_at: raw.updated_at
  };
};
